import Blue from "~/core";
import Swiper from "swiper";
import {
  Navigation,
  Pagination,
  A11y,
  Keyboard,
  Autoplay,
} from "swiper/modules";

const DEFAULT_SLIDE_DELAY = 5000;
const DEFAULT_ANIMATION_TIME = 500;
let timeout = null;

Swiper.use([Navigation, Pagination, A11y, Keyboard, Autoplay]);

new Blue({
  name: "Hero Slider",
  selector: ".hero__carousel",
  setup(heroSlider) {
    const circle = heroSlider.querySelector(".icon-progress");
    const autoplayToggle = heroSlider.querySelector(".swiper-autoplay-toggle");

    const transitionTime = heroSlider.dataset.transitionTime ? +heroSlider.dataset.transitionTime : DEFAULT_SLIDE_DELAY;
    const animationTime = heroSlider.dataset.animationTime ? +heroSlider.dataset.animationTime : DEFAULT_ANIMATION_TIME;

    let swiper = new Swiper(heroSlider.querySelector(".swiper"), {
      watchOverflow: true,
      keyboard: true,
      a11y: true,
      loop: true,
      speed: animationTime,
      autoplay: {
        delay: transitionTime,
        disableOnInteraction: true,
      },
      pagination: {
        el: heroSlider.querySelector(".swiper-pagination"),
        clickable: true,
      },
      navigation: {
        nextEl: heroSlider.querySelector(".swiper-button-next"),
        prevEl: heroSlider.querySelector(".swiper-button-prev"),
      },
      on: {
        autoplayTimeLeft: handleAutoplayTimeLeft,
        autoplayStart: checkAutoplayState,
        autoplayStop: checkAutoplayState,
        autoplayPause: checkAutoplayState,
        autoplayResume: checkAutoplayState,
      },
    });

    autoplayToggle.addEventListener("click", () => {
      if (!swiper.autoplay.running)
        swiper.autoplay.start();
      else 
        swiper.autoplay.stop();
    });

    function handleAutoplayTimeLeft(s, time, progress) {
      const safeProgress = Math.min(Math.max(progress, 0), 1);
      circle.style.setProperty("--progress", 1 - safeProgress);
    }

    function checkAutoplayState(s) {
      if (s.autoplay.running) 
        autoplayToggle.classList.remove("is-paused");
      else {
        autoplayToggle.classList.add("is-paused");
        handleAutoplayTimeLeft(s, 0, 1);
      }
    }
  },
});
